<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="ch19"></a><a id="page_20"></a><a href="#/contents#ch19"><b>Music Men</b></a></h2>
<p class="noindent"><span>Ted Nugent has been a Michigan sheriff’s deputy since 1978.</span></p>
<p class="noindent"><span>Marilyn Manson’s real name: Brian Hugh Warner.</span></p>
<p class="noindent"><span>When Elvis Presley was three years old, his father altered a check from his employer (raising his pay from $3 to $8). The punishment: the King’s dad spent eight months in the Mississippi State Penitentiary.</span></p>
<p class="noindent"><span>Rob Zombie’s first job in entertainment: as a production assistant on the 1980s TV show <i>Pee-wee’s Playhouse</i>.</span></p>
<p class="noindent"><span>Michael Jackson’s first onstage moonwalk: 1983.</span></p>
<p class="noindent"><span>What does LL Cool J’s name stand for? “Ladies Love Cool James.” (His real name is James Todd Smith.)</span></p>
<p class="noindent"><span>B. B King was playing a concert in 1949 when two men fighting over a woman named Lucille accidentally set fire to the club he was playing in. King risked his life to save his $30 guitar, and when the ordeal was over, he named it— and all his future guitars—after the woman at the center of the ruckus.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter19.vue?7714fc95